import { META } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#0B0A0E] text-white border-t border-[#C9B68B]/15">
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-16 grid md:grid-cols-[1.4fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif text-3xl text-white" dangerouslySetInnerHTML={{ __html: META.brand }} />
          <p className="font-serif italic text-base text-white/55 mt-1">{META.tagline}</p>
          <p className="text-sm text-white/55 mt-6 leading-[1.7] max-w-md">An Antwerp-trained diamond atelier. Two stones, two pieces, twenty-four hands &mdash; per year. The waiting list is currently fourteen months.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9B68B] mb-3">Antwerp · Atelier</p>
          <p className="text-sm text-white/75 leading-relaxed">Pelikaanstraat 14, 2018<br />By appointment only</p>
          <p className="font-mono text-[11px] text-white/45 mt-3">+32 3 555 0184</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9B68B] mb-3">London · Atelier</p>
          <p className="text-sm text-white/75 leading-relaxed">86 Mount Street, Mayfair W1K 2SP<br />Wednesday — Saturday, by appointment</p>
          <p className="font-mono text-[11px] text-white/45 mt-3">+44 20 7993 0184</p>
        </div>
      </div>
      <div className="border-t border-white/10 px-8 lg:px-14 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-white/30">
        <span>© 2026 {META.brand.replace('&', '&')} · Master Diamantair certified, Antwerp Diamond Bourse</span>
        <div className="flex gap-6">
          <button onClick={() => setPage('process')} className="hover:text-[#C9B68B]">The Process</button>
          <a href="#" className="hover:text-[#C9B68B]">Sourcing Notes</a>
          <a href="#" className="hover:text-[#C9B68B]">Privacy</a>
        </div>
      </div>
    </footer>
  );
}
